import { useState, useEffect } from "react";
import Navigation2 from "../navigation2";
import { withRouter } from "react-router-dom";
import axios from "axios";
import "react-toastify/dist/ReactToastify.css";
import Footer from "../../screens/footer";
import AddPassport from "../components/addPassport";
import AddTicket from "../components/addTicket";
import AddVisa from "../components/addVisa";
import AddHotel from "../components/addHotel";
import AddManpower from "../components/addManpower";
import AddMedical from "../components/addMedical";
import Addumrah from "../components/addUmrah";
import AddHajj from "../components/addHajj";

function Adservice(props) {
  var cid = props.match.params.cid;
  const [active, setActive] = useState("dom");

  const [cserial, setCserial] = useState("");
  const [cname, setCname] = useState("");
  const [cnum, setCnum] = useState("");
  const [passport, setPassport] = useState("");
  const [ctype, setCtype] = useState("regular");
  const [aid, setAid] = useState("");
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    console.log(cid);
    axios
      .post(
        "https://concorde-api.flydocx.com/" +
          process.env.REACT_APP_URL +
          "/userfetch",
        {
          id: cid,
        },
      )
      .then((res) => {
        setCname(res.data.message[0].cname);
        setCnum(res.data.message[0].cnum);
        setCserial(res.data.message[0].serial);
        setPassport(res.data.message[0].passport);
      })
      .catch((err) => console.log(err));
  }, [cid]);

  useEffect(() => {
    axios
      .post(
        "https://concorde-api.flydocx.com/" +
          process.env.REACT_APP_URL +
          "/fetchagent",
      )
      .then((res) => setAgents(res.data.message))
      .catch((err) => console.log(err));
  }, []);

  return (
    <>
      <Navigation2 />

      <div class="container">
        <div class="addCustomer">
          <div class="border bg-light mb-3">
            <h5 class="m-0 border-bottom px-3 py-2 mb-3">Customer Info</h5>
            <div class="row px-3 ">
              <label for="" class="col-lg-2 col-12 infotext">
                Customer Serial
              </label>
              <div class="col-lg-4 col-12">
                <p>: {cserial}</p>
              </div>
            </div>

            <div class="row px-3">
              <label for="" class="col-lg-2 col-12 infotext">
                Customer Name
              </label>
              <div class="col-lg-4 col-12">
                <p>: {cname}</p>
              </div>

              <label for="" class="col-lg-2 col-12 infotext">
                Passport Number
              </label>
              <div class="col-lg-4 col-12">
                <p>: {passport}</p>
              </div>
            </div>
          </div>
          {/* <div class="d-flex adcst col-lg-12 col-12">
            <h3 class="m-0">Add Service</h3>  
          </div> */}

          <div class="form-group row bg-light border mx-auto mb-0">
            <label class="col-lg-12 col-12 border-bottom infotext py-2 mb-0 font-weight-bold">
              Service type
            </label>
            <div class="d-flex col-lg-12 col-12 p-0 m-0 justify-content-between">
              <div
                onClick={() => {
                  setActive("dom");
                }}
                class={
                  active.includes("dom")
                    ? "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread"
                    : "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread2"
                }
              >
                <label for="_0" class="form-check-label infotext mr-2">
                  Domestic Ticket
                </label>
              </div>

              <div
                onClick={() => {
                  setActive("int");
                }}
                class={
                  active.includes("int")
                    ? "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread"
                    : "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread2"
                }
              >
                <label for="_0" class="form-check-label infotext mr-2">
                  International Ticket
                </label>
              </div>

              <div
                onClick={() => {
                  setActive("visa");
                }}
                class={
                  active.includes("visa")
                    ? "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread"
                    : "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread2"
                }
              >
                <label for="_0" class="form-check-label infotext mr-2">
                  Visa
                </label>
              </div>

              <div
                onClick={() => {
                  setActive("hotel");
                }}
                class={
                  active.includes("hotel")
                    ? "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread"
                    : "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread2"
                }
              >
                <label for="_0" class="form-check-label infotext mr-2">
                  Hotel
                </label>
              </div>

              <div
                onClick={() => {
                  setActive("manpower");
                }}
                class={
                  active.includes("manpower")
                    ? "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread"
                    : "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread2"
                }
              >
                <label for="_0" class="form-check-label infotext mr-2">
                  Manpower
                </label>
              </div>

              <div
                onClick={() => {
                  setActive("medical");
                }}
                class={
                  active.includes("medical")
                    ? "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread"
                    : "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread2"
                }
              >
                <label for="_0" class="form-check-label infotext mr-2">
                  Medical
                </label>
              </div>

              <div
                onClick={() => {
                  setActive("umrah");
                }}
                class={
                  active.includes("umrah")
                    ? "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread"
                    : "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread2"
                }
              >
                <label for="_0" class="form-check-label infotext mr-2">
                  Umrah
                </label>
              </div>

              <div
                onClick={() => {
                  setActive("hajj");
                }}
                class={
                  active.includes("hajj")
                    ? "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread"
                    : "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread2"
                }
              >
                <label for="_0" class="form-check-label infotext mr-2">
                  Hajj
                </label>
              </div>
              <div
                onClick={() => {
                  setActive("passport");
                }}
                class={
                  active.includes("passport")
                    ? "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread"
                    : "flex-fill form-check form-check-inline m-0 p-0 checkboxSpread2"
                }
              >
                <label for="_0" class="form-check-label infotext mr-2">
                  Passport
                </label>
              </div>
            </div>
          </div>
        </div>
        <div className="container border mb-4 bg-light pt-3">

  {/* Customer Type */}
  <div className="form-group row py-1">
    <label className="col-lg-2 col-12 col-form-label infotext">
      Customer Type
    </label>

    <div className="col-lg-4 mt-2">
      <div className="form-check form-check-inline">
        <input
          type="radio"
          name="ctype"
          value="regular"
          className="form-check-input"
          checked={ctype === "regular"}
          onChange={(e) => setCtype(e.target.value)}
        />
        <label className="form-check-label mr-3">
          Regular
        </label>
      </div>

      <div className="form-check form-check-inline">
        <input
          type="radio"
          name="ctype"
          value="agent"
          className="form-check-input"
          checked={ctype === "agent"}
          onChange={(e) => setCtype(e.target.value)}
        />
        <label className="form-check-label">
          From Agent
        </label>
      </div>
    </div>
  </div>

  {/* Agent Name */}
  {ctype === "agent" && (
    <div className="form-group row py-1">
      <label className="col-lg-2 col-12 col-form-label infotext">
        Agent Name
      </label>

      <div className="col-lg-4 col-12">
        <select
          className="form-control"
          value={aid}
          onChange={(e) => setAid(e.target.value)}
        >
          <option value="">Choose Agent</option>

          {agents.map((item) => (
            <option key={item.id} value={item.id}>
              {item.aname}
            </option>
          ))}
        </select>
      </div>
    </div>
  )}

  {/* Tabs */}
  {active === "passport" ? (
    <AddPassport cid={cid} ctype={ctype} aid={aid} />
  ) : active === "int" ? (
    <AddTicket cid={cid} ctype={ctype} aid={aid} active={active} />
  ) : active === "dom" ? (
    <AddTicket cid={cid} ctype={ctype} aid={aid} active={active} />
  ) : active === "visa" ? (
    <AddVisa cid={cid} ctype={ctype} aid={aid} />
  ) : active === "hotel" ? (
    <AddHotel cid={cid} ctype={ctype} aid={aid} />
  ) : active === "manpower" ? (
    <AddManpower cid={cid} ctype={ctype} aid={aid} />
  ) : active === "medical" ? (
    <AddMedical cid={cid} ctype={ctype} aid={aid} />
  ) : active === "umrah" ? (
    <Addumrah cid={cid} ctype={ctype} aid={aid} />
  ) : active === "hajj" ? (
    <AddHajj cid={cid} pass={passport} ctype={ctype} aid={aid} />
  ) : null}

</div>
      </div>

      <Footer />
    </>
  );
}

export default withRouter(Adservice);
